














































import { mapDeps } from '~/plugins/dependency-container/utils'
import RelatedClassifiedsService from '~/services/classified/RelatedClassifiedsService'
import { mapState } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import Feed from '~/components/car/classifieds/index/feeds/Feed.vue'
import RelatedSearch from '~/components/shared/classified/view/RelatedSearch.vue'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { RelatedSearch, Feed },
  data() {
    return {
      feeds: [],
      relatedSearches: [],
      loading: true
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, ['classifiedId']),
    ...mapDeps({
      relatedClassifiedsService: RelatedClassifiedsService
    }),
    relatedSearchesToShow() {
      if (this.relatedSearches.length === 0) {
        return this.relatedSearches
      }
      return this.relatedSearches.filter(s => s.searches.length > 1)
    }
  },
  methods: {
    handleVisibilityChange(isVisible: boolean) {
      if (isVisible) {
        return this.loadRelatedClassifieds()
      }
    },
    async loadRelatedClassifieds() {
      try {
        const {
          searches,
          feeds
        } = await this.relatedClassifiedsService.getRelatedClassifieds(
          this.classifiedId
        )
        if (searches?.length) {
          this.relatedSearches = searches
        }
        this.feeds = feeds
      } catch (error) {
        error.message = `Failed to load related classifieds for classified with id ${this.classifiedId}: ${error}`
        this.$logger.captureError(error)
      } finally {
        this.loading = false
      }
    }
  }
})
